import {AfterViewInit, Component, OnDestroy, OnInit, Renderer2, ViewChild} from '@angular/core';
import {RxJSUnsubscribable} from '../../../../../../../../core/src/lib/core/utils/interfaces/rxjs-unsubscribable';
import {OverlayPanel} from 'primeng/overlaypanel';
import {MatDialog} from '@angular/material/dialog';
import {ProjectActivityService} from '../../../../project-misc/data/project/activity/project-activity.service';
import {ProductionPlanningProjectsService} from '../../../data/production-planning-projects.service';
import {ConfirmationService} from 'primeng/api';
import {DeviceDetectorService} from 'ngx-device-detector';
import {Calendar, DatesSetArg, EventClickArg, EventContentArg, EventDropArg, EventInput, CalendarOptions, EventApi} from '@fullcalendar/core';
import resourceTimelinePlugin from '@fullcalendar/resource-timeline';
import interactionPlugin from '@fullcalendar/interaction';
import moment from 'moment';
import jQuery, * as jq from 'jquery';
import {Subject, Subscription} from 'rxjs';
import {transaction} from '@datorama/akita';
import {RxJSUnsubscribe} from '../../../../../../../../core/src/lib/core/utils/decorators/rxjs-unsubscribe-decorator';
import {FcRenderEvent} from '../../../../../../../../desktop/src/app/modules/full-calendar/data/fc-render-event';
import {
  ProjectWindowComponent
} from '../../../../../../../../desktop/src/app/modules/project/view/project-window/project-window.component';
import {ProductionPlanningEvent} from '../../../data/production-planning-event';
import {debounceTime, finalize} from 'rxjs/operators';
import {autoSubscribe, tapOnError} from '../../../../../../../../core/src/lib/core/utils/rxjs.utils';
import {FcJsEvent} from '../../../../../../../../desktop/src/app/modules/full-calendar/data/fc-js-event';
import {ProjectActivity} from '../../../../project-misc/data/project/activity/project-activity';
import {
  CalendarEventTipService
} from '../../../../../../../../desktop/src/app/modules/full-calendar/data/calendar-event-tip.service';
import {
  ProdPostEditorDialogComponent
} from '../../../../admin-panel/view/activities-editor/prod-post-editor-dialog/prod-post-editor-dialog.component';
import {RouterService} from '../../../../../../../../core/src/lib/misc/router/router.service';

// Simple interface for resource object structure
interface ResourceLike {
  id: string;
  title: string;
  extendedProps: {
    postId: string;
    totalCapacity: number;
    usedCapacity: number;
    weekToReview?: Date;
  };
}

class ResourceClass {
  id: string;
  title: string;
  eventColor: string;
  extendedProps: {
    postId: string;
    totalCapacity: number;
    usedCapacity: number;
    weekToReview?: Date;
  };
}

@Component({
  selector: 'app-activity-calendar',
  templateUrl: './activity-calendar.component.html',
  styleUrls: ['./activity-calendar.component.scss'],
  providers: [
    ProductionPlanningProjectsService,
    DeviceDetectorService,
    ConfirmationService,
    CalendarEventTipService
  ]
})

@RxJSUnsubscribe
export class ActivityCalendarComponent implements OnInit, AfterViewInit, OnDestroy, RxJSUnsubscribable {

  @ViewChild('ppfc', {static: true})
  ppfc: any;

  @ViewChild('eventHintOP', {static: true})
  eventHintOP: OverlayPanel

  @ViewChild('holidayOp', {static: true})
  holidayOp: OverlayPanel

  options: any;

  calendarEvents: EventInput[] = []

  loadingCalendar: boolean;

  filteredPostsSet = new Set()


  isMobile = false;
  isTablet = false;
  isDesktop = false;

  rejectReason = '';

  choosenDaysMap = new Map();

  approveLoading: boolean;
  rejectLoading: boolean;

  tempTarget: any;

  holidayStr: string;

  subToDateChangesSubj = new Subject<DatesSetArg>();
  filterSubj: Subscription;

  activityEvents: ProductionPlanningEvent[]

  allActivityResources: ResourceClass[] = []
  filteredActivityResources: ResourceClass[] = []

  activityInHint: ProjectActivity;

  activitiesMap = new Map<string, ProjectActivity>();
  eventsMap = new Map<string, EventInput>();
  postsMap = new Map<string, ProductionPlanningEvent>();
  eventsPositions = new Map<number, number[]>();
  isDragging = false;
  dragPrevPos: number;
  dragCurrIdx: number;
  draggingContainer: HTMLElement = null;
  draggingList: HTMLElement[] = null;
  draggingElement: HTMLElement = null;
  stubElement: HTMLElement = null;

  startDate = moment().startOf('week').format('YYYY-MM-DD');
  endDate = moment().endOf('week').format('YYYY-MM-DD');

  postEditListenerFn = () => {
  };

  dragListener: EventListenerOrEventListenerObject = (event: MouseEvent) => {
    if (this.draggingList === null || this.draggingElement === null) {
      this.draggingList = Array.from(this.draggingContainer.getElementsByClassName('fc-timeline-event-harness')) as HTMLElement[];
      this.draggingElement = this.draggingList[this.draggingList.length - 1] as HTMLElement;
      this.draggingElement.style.transition = 'none';
      this.draggingElement.style.width = 'auto';
      this.draggingList = this.draggingList.slice(0, this.draggingList.length - 1);
      this.dragPrevPos = this.draggingElement.offsetLeft
    }
    let edge = this.draggingElement.offsetLeft

    if (this.dragPrevPos === edge) {
      return
    } else if (this.dragPrevPos === undefined || this.dragPrevPos === null) {
      this.dragPrevPos = edge;
    }

    const forward = edge > this.dragPrevPos;
    if (forward) {
      edge += this.draggingElement.offsetWidth
    }

    const target = this.draggingList.findIndex((el: HTMLElement, i: number) => {
      if (i === this.dragCurrIdx) {
        return false
      }
      const mid = el.offsetLeft + (el.offsetWidth / 2);
      if (forward && i > this.dragCurrIdx) {
        return edge > mid && (i === this.draggingList.length - 1 || edge < this.draggingList[i + 1].offsetLeft);
      } else if (!forward && i < this.dragCurrIdx) {
        return edge < mid && (i === 0 || edge > this.draggingList[i - 1].offsetLeft);
      }

      return (mid > Math.min(this.dragPrevPos, edge) && mid < Math.max(this.dragPrevPos, edge))
    })

    if (target !== this.dragCurrIdx && target !== -1) {
      const elements = this.draggingList.slice(Math.min(this.dragCurrIdx, target), Math.max(this.dragCurrIdx, target) + 1);

      (forward ? elements : elements.reverse()).forEach((el: HTMLElement, i: number) => {
        if (forward) {
          let offset = (el.offsetLeft - this.draggingElement.offsetWidth);
          if (offset < 0) {
            offset = 0
          }
          el.style.left = offset + 'px';
        } else {
          let offset = (el.offsetLeft + this.draggingElement.offsetWidth);
          if (offset < 0) {
            offset = 0
          }
          this.stubElement.style.left = (el.offsetLeft - this.draggingElement.offsetWidth) + 'px';
          el.style.left = offset + 'px';
        }
      })
      if (forward) {
        this.stubElement.style.left = this.draggingElement.style.left;
      }
      this.draggingList = this.draggingList.sort((a: HTMLElement, b: HTMLElement) => a.offsetLeft - b.offsetLeft);
      this.dragCurrIdx = target;
    }
    this.dragPrevPos = this.draggingElement.offsetLeft;
  }

  constructor(
    protected dialog: MatDialog,
    protected renderer: Renderer2,
    protected projectActivityService: ProjectActivityService,
    protected productionPlanningProjectsService: ProductionPlanningProjectsService,
    protected confirmationService: ConfirmationService,
    protected deviceDetectorService: DeviceDetectorService,
    protected calendarEventTipService: CalendarEventTipService,
    protected routerService: RouterService
  ) {
    this.isMobile = this.deviceDetectorService.isMobile();
    this.isTablet = this.deviceDetectorService.isTablet();
    this.isDesktop = this.deviceDetectorService.isDesktop();
  }

  get calendar(): Calendar {
    return this.ppfc.calendar as Calendar
  }

  ngOnInit(): void {
    this.calendarEventTipService.eventHintOP = this.eventHintOP;

    this.subToFilter()
    this.subToDateChanges();

    this.options = {
      schedulerLicenseKey: 'CC-Attribution-NonCommercial-NoDerivatives',
      plugins: [resourceTimelinePlugin, interactionPlugin],
      resourceAreaWidth: '170px',
      initialDate: this.startDate,
      initialView: 'resourceTimelineWeek',
      buttonText: {
        today: 'This Week',
      },
      headerToolbar: {
        left: '',
        center: 'prev,title,next today',
        right: ''
      },
      slotMinWidth: 5,
      slotDuration: {minutes: 30},
      slotLabelInterval: {hours: 24},
      slotMinTime: '00:00:00',
      slotMaxTime: '24:00:00',
      editable: true,
      eventDurationEditable: false,
      eventResourceEditable: false,
      displayEventTime: false,
      nowIndicator: false,
      slotEventOverlap: true,
      eventOverlap: true,
      selectOverlap: true,
      weekends: false,
      resources: [],
      events: [],
      eventClick: (info: EventClickArg) => {
        this.onEventClick(info)
      },
      eventDrop: (info: EventDropArg) => {
        this.onEventDrop(info)
        info.el.classList.remove('event-on-hover');
      },
      datesSet: (info: DatesSetArg) => {
        this.loadingCalendar = true;

        this.subToDateChangesSubj.next(info)
      },
      resourceLabelContent: (arg) => {
        return this.postRenderTemplate(arg.resource);
      },
      eventContent: (info: EventContentArg) => {
        return this.eventRenderTemplate(info);
      },
      eventDidMount: (info: EventContentArg) => {
        this.eventDidMount(info)
      },
      eventMouseEnter: (info: EventClickArg) => {
        info.el.classList.add('event-on-hover');
      },
      eventMouseLeave: (info: EventClickArg) => {
        info.el.classList.remove('event-on-hover');
      },
      eventDragStop: () => {
        this.isDragging = false
        document.getElementsByClassName('fc-timeline-body')[0].removeEventListener('mousemove', this.dragListener)
        this.draggingContainer = null
        this.draggingList = null
        this.draggingElement = null
        this.stubElement = null
      },
      eventDragStart: (info: EventClickArg) => {
        this.eventDragStarted(info)
      }
    };
  }

  eventDragStarted(info: EventClickArg) {
    this.isDragging = true;
    this.stubElement = info.el.parentElement;
    this.draggingContainer = this.stubElement.parentElement;
    const elements = this.draggingContainer.getElementsByClassName('fc-timeline-event-harness');
    const postId = +info.event.extendedProps.postId;

    [].forEach.call(elements, (el: HTMLElement, i: number) => {
      el.style.width = el.offsetWidth + 'px';
      el.style.right = 'auto'
      this.eventsPositions.set(postId, [el.offsetLeft, el.offsetWidth])
      if (el === this.stubElement) {
        this.dragCurrIdx = i
      }
    })

    const observer = new MutationObserver(e => {
      if (e[0].removedNodes) {
        this.draggingElement = null
      }
    });

    observer.observe(this.draggingContainer, {childList: true});
    document.getElementsByClassName('fc-timeline-body')[0].addEventListener('mousemove', this.dragListener);
  }

  eventRenderTemplate(eventInfo: EventContentArg) {
    if (!this.activitiesMap.has(eventInfo.event.id)) {
      return
    }

    const projectActivity = this.activitiesMap.get(eventInfo.event.id)


    let shortCode = projectActivity.type.shortCode

    const userCode = projectActivity.user?.shortCode ? '(' + projectActivity.user?.shortCode + ')' : ''

    if (!shortCode) {
      shortCode = '-'
    }

    let htmlSpanToShow = shortCode;

    if (projectActivity.type.name === 'PunchListDue' && projectActivity.isSample) {
      htmlSpanToShow = 'S' + htmlSpanToShow
    }

    if (projectActivity.type.name === 'Installation') {
      htmlSpanToShow += userCode
    }

    if (projectActivity.type.name === 'FinishingSubmit' || projectActivity.type.name === 'FinishingPickup') {
      if (projectActivity.project.finishingVendor && projectActivity.project.finishingVendor.name === 'Acadia Craft') {
        htmlSpanToShow += ('(AC)')
      }
      if (projectActivity.project.finishingVendor && projectActivity.project.finishingVendor.name === 'PCFI FINISHING') {
        htmlSpanToShow += ('(PCFI)')
      }
    }

    const uiDuration = eventInfo.event.extendedProps.uiDurationSeconds / 60 / 60
    const duration = eventInfo.event.extendedProps.totalDurationSeconds / 60 / 60
    let boxClass = duration > 10 ? 'wide' : ''
    if (uiDuration <= 5) {
      boxClass += ' narrow'
    }
    if (uiDuration <= 3) {
      boxClass += ' nowrap'
    }

    let userName = '';
    if (projectActivity.user) {
      userName = projectActivity.user.shortCode
    }

    return {
      html: `
  		<div class="fc-content">
  			<div class="event-box ${boxClass}">
  				<div class="event-title">
  					<span class="event-title-span">${eventInfo.event.title}<span>
  				</div>
  				<div class="delivery-instruction-mark">
            <i class="pi pi-exclamation-triangle" style="font-size: 100%"></i>
  				</div>
  				<div class="event-dot-container">
  					<div class="event-dot"></div>
  				</div>
  				<div class="event-shortcode">
  					<span class="activity-short-code">${htmlSpanToShow}</span>
  					<span class="activity-duration">${duration}h</span>
  				</div>
  				<div class="activity-user"">
  					<span class="activity-user-name">${userName}</span>
  				</div>
  			</div>
  		</div>
  	`
    }
  }

  postRenderTemplate(res: ResourceLike) {
    const exceeding = res.extendedProps.totalCapacity < res.extendedProps.usedCapacity;
    const showWeekButton = !!res.extendedProps.weekToReview;

    return {
      html: `
  		<div class="post-info">
        <div class="post-title">
          <span class="post-title-span">
            ${res.title}
          <i class="pi pi-cog post-edit-icon" pTooltip="Edit" tooltipPosition="bottom" id="event-${res.extendedProps.postId}"></i>
          </span>
        </div>
        <div class="post-capacity-info">
          <span class="post-capacity-title exceeding-${exceeding}">
          Scheduled hours:
          <i class="pi pi-exclamation-triangle" pTooltip="Exceeding capacity!" tooltipPosition="bottom"></i>
          </span>
          <span class="post-capacity-usage">${res.extendedProps.usedCapacity} of ${res.extendedProps.totalCapacity}</span>
        </div>
        <div class="week-block show-block-${showWeekButton}">
            <button class="week-button" id="week-${res.extendedProps.postId}">Past Due Activities</button>
        </div>
  		</div>
  	`
    }
  }

  changeDate(id: string) {
    const post = this.postsMap.get(id).post

    this.startDate = moment(post.weekToReview).startOf('week').format('YYYY-MM-DD');
    this.endDate = moment(post.weekToReview).endOf('week').format('YYYY-MM-DD');

    this.calendar.gotoDate(this.startDate)

    // this.getEvents(this.startDate, this.endDate)
  }

  getEvents(start: string, end: string) {
    this.activityEvents = [];
    this.allActivityResources = [];
    this.calendarEvents = [];


    this.productionPlanningProjectsService.getEvents(start, end).subscribe(events => {
      this.activityEvents = events

      console.log(this.activityEvents)

      this.fillEvents()

      if (this.calendar) {
        this.calendar.setOption('resources', this.allActivityResources);
      }

      this.loadingCalendar = false;
    })
  }

  filterPosts() {
    this.fillBgEvents()

    this.filteredActivityResources = this.allActivityResources.filter(post => this.filteredPostsSet.has(post.title))

    if (this.calendar) {
      this.calendar.setOption('resources', this.filteredActivityResources);
    }
  }

  fillEvents() {
    this.activitiesMap.clear()
    this.eventsMap.clear()
    this.activityEvents.forEach(activityEvent => {// each post
      activityEvent.postWeek.productionPost.weekToReview = activityEvent.weekToReview;

      this.postsMap.set(activityEvent.post.id + '', activityEvent)

      const totalDuration = activityEvent.duration
      const weekDuration = 5 * 24 * 60 * 60;

      let lastEndDate = moment(this.startDate).toDate()
      const activities = activityEvent.activities.map(activity => {// each activity
        this.activitiesMap.set(activity.id + '', activity)
        let seconds = activity.duration

        if (totalDuration > weekDuration) {
          seconds = seconds * weekDuration / totalDuration
        }

        let halfHours = Math.floor(seconds / (30 * 60))
        if (halfHours < 5) {// weird bug with fullcalendar with events shorter than 2.5 hours
          halfHours = 5
        }
        seconds = halfHours * 30 * 60
        activity.startDate = lastEndDate
        activity.endDate = moment(activity.startDate).add(seconds, 'seconds').toDate()
        lastEndDate = activity.endDate

        const event = {
          id: activity.id + '',
          start: activity.startDate,
          end: activity.endDate,
          title: activity.project.name,
          resourceId: activityEvent.postWeek.productionPost.id + '',
          backgroundColor: '#' + activity.type.color,
          color: '#494949',
          projectId: activity.project.id,
          postId: activityEvent.postWeek.productionPost.id,
          postDuration: activityEvent.duration,
          totalDurationSeconds: activity.duration,
          uiDurationSeconds: seconds,
          activityType: activity.type.name,
          classNames: [
            `activity-type-${activity.type.name}`,
            `ready-${activity.ready}`,
            `activity-trimmed-${activity.isDurationTrimmed}`,
            `has-user-${!!activity.user}`]
        };
        this.eventsMap.set(event.id, event as EventInput)
        return event
      })

      this.calendarEvents = this.calendarEvents.concat(activities)
    })


    this.activityEvents.forEach(event => {

      this.allActivityResources.push({
        id: event.post.id + '',
        title: event.post.name,
        eventColor: event.activities?.length ? '#' + event.activities[0].type.color : '',
        extendedProps: {
          postId: event.post.id + '',
          totalCapacity: event.postWeek.capacity,
          usedCapacity: Math.ceil(event.duration / 60 / 60),
          weekToReview: event.weekToReview
        }
      })
    })

    // Update calendar with events
    if (this.calendar) {
      this.calendar.removeAllEvents();
      this.calendar.addEventSource(this.calendarEvents);
    }
  }

  fillBgEvents() {
    if (!this.allActivityResources || this.allActivityResources.length === 0 || !this.calendar) {
      return;
    }

    this.allActivityResources.forEach(res => {
      // green bg
      this.calendar.addEvent({
        start: moment(this.startDate).startOf('week').format('YYYY-MM-DD'),
        end: moment(this.endDate).startOf('week').add(4, 'day').format('YYYY-MM-DD'),
        display: 'background',
        color: '#cff2d8',
        resourceId: res.id + ''
      });

      // yellow
      this.calendar.addEvent({
        start: moment(this.startDate).startOf('week').add(4, 'day').format('YYYY-MM-DD'),
        end: moment(this.endDate).startOf('week').add(5, 'day').format('YYYY-MM-DD'),
        display: 'background',
        color: '#f2eccf',
        resourceId: res.id + ''
      });

      // red
      this.calendar.addEvent({
        start: moment(this.startDate).startOf('week').add(5, 'day').format('YYYY-MM-DD'),
        end: moment(this.endDate).startOf('week').add(6, 'day').format('YYYY-MM-DD'),
        display: 'background',
        color: '#ffc5c5',
        resourceId: res.id + ''
      });
    });
  }

  eventDidMount(eventInfo) {
    if (!this.activitiesMap.has(eventInfo.event.id)) {
      return
    }

    const projectActivity = this.activitiesMap.get(eventInfo.event.id)

    eventInfo.el.style.setProperty('--activity-type-color', '#' + projectActivity.type.color)

    const cls = 'event-box'
    const el = eventInfo.el.getElementsByClassName(cls);

    // tslint:disable-next-line: deprecation
    jq(el).hover(() => {
      this.showHint(eventInfo, cls)
    }, () => {
      this.hideHint()
    })

    const eventEl = jQuery(eventInfo.el)

    // tslint:disable-next-line: deprecation
    eventEl.dblclick(() => {
      this.openProjectWindow(eventInfo)
    })
  }

  openProjectWindow(eventInfo: FcRenderEvent): void {
    if (!eventInfo.event.extendedProps.projectId) {
      return
    }
    // const clickedProjectActivity = this.calendarEventsService.eventsMap.get(eventInfo.event.id)

    const projectWindow = ProjectWindowComponent as any;

    const panelClass = 'project-window-dialog'

    const dialogRef = this.dialog.open(projectWindow, {
      data: {
        projectNumber: eventInfo.event.extendedProps.projectId,
      },
      panelClass
    });

    dialogRef.afterClosed().subscribe(() => {
      this.getEvents(this.startDate, this.endDate)
    })

  }

  scrollToToday() {
    const scrollElems: HTMLElement[] = this.ppfc.element.nativeElement.getElementsByClassName('fc-scroller');
    const scrollEl: HTMLElement = scrollElems[0]
    const todayElems = scrollEl.getElementsByClassName('fc-day-today')
    // todayElems[0].scrollIntoView()
    if (todayElems.length >= 2) {

      setTimeout(() => {
        todayElems[1].scrollIntoView();
      }, 1)

    }
  }

  removeActivity(planningEvent: ProductionPlanningEvent, activityEvent: EventApi) {
    this.calendarEvents.splice(this.calendarEvents.findIndex(e => e.id === activityEvent.id), 1)
    planningEvent.activities.splice(planningEvent.activities.findIndex(a => a.id === +activityEvent.id), 1)
    activityEvent.remove()
    this.chainActivities(planningEvent, activityEvent.extendedProps.uiDurationSeconds)
  }

  addEvent(planningEvent: ProductionPlanningEvent, activityEvent: EventApi) {
    this.calendar.addEvent(activityEvent)
    this.chainActivities(planningEvent)
  }

  chainActivities(event: ProductionPlanningEvent, removedSeconds = 0) {// removes gaps and moves activities to the start of the week
    const activities = event.activities
    let prevEndDate = moment(this.startDate).toDate()

    activities.forEach((activity, i) => {
      const e = this.calendar.getEventById(activity.id.toString())
      let seconds = e.extendedProps.uiDurationSeconds
      if (removedSeconds) {
        seconds += removedSeconds / activities.length
      }
      activity.startDate = prevEndDate
      activity.endDate = moment(activity.startDate).add(seconds, 'seconds').toDate()
      e.setStart(activity.startDate)
      e.setEnd(activity.endDate)
      if (removedSeconds > 0) {// FullCalendar does not update event's width, so we need to remove and add it again
        e.remove()
        this.calendar.addEvent(e)
      }
      prevEndDate = activity.endDate
    })
    event.activities = activities
  }

  moveActivityToAnotherWeek(info: EventDropArg, productionPlanningEvent: ProductionPlanningEvent, forward: boolean) {
    this.removeActivity(productionPlanningEvent, info.event)// changing ui first to make it smoother

    const targetWeekStart = forward ? moment(this.startDate).add(7, 'days') : moment(this.startDate).subtract(7, 'days')
    this.productionPlanningProjectsService.moveToAnotherWeek(
      +info.event.id,
      productionPlanningEvent.post.id,
      this.startDate,
      targetWeekStart.format('YYYY-MM-DD')
    ).pipe(
      finalize(() => {
        this.getEvents(this.startDate, this.endDate)// refetch events to update dates and durations
      }),
      tapOnError(() => {
        this.addEvent(productionPlanningEvent, info.oldEvent)
      }),
      autoSubscribe()
    )
  }

  moveActivityWithinWeek(activityId: number, postId: number, pos: number) {
    this.productionPlanningProjectsService.moveWithinWeek(activityId, postId, this.startDate, pos)
      .pipe(
        finalize(() => {
          this.getEvents(this.startDate, this.endDate)// refetch events to update dates and durations
        }),
        autoSubscribe()
      )
  }

  onEventDrop(info: EventDropArg) {
    const eventId = +info.event.id
    const postId = +info.event.extendedProps.postId;
    const productionPlanningEvent = this.activityEvents.find(activityEvent =>
      activityEvent.post.id === postId
    )
    const activities = productionPlanningEvent.activities
    const forward = moment(info.event.start).isAfter(info.oldEvent.start)
    const eventEdgeDate = forward ? moment(info.event.end) : moment(info.event.start);

    if (forward && moment(this.endDate).isBefore(eventEdgeDate)
      || !forward && moment(this.startDate).isAfter(eventEdgeDate)) {
      this.moveActivityToAnotherWeek(info, productionPlanningEvent, forward)
      return
    }

    let targetActivity = activities.find(a => a.id !== eventId && eventEdgeDate.isBetween(a.startDate, a.endDate, undefined, '[]'))

    if (targetActivity == null) {
      targetActivity = activities[activities.length - 1]
    }

    if (targetActivity != null && targetActivity.id !== eventId) {
      let targetIndex = activities.findIndex(activity => activity.id === +targetActivity.id);
      const currIndex = activities.findIndex(activity => activity.id === eventId);

      const end = moment(targetActivity.endDate);
      const threshold = end.subtract(moment.duration(end.diff(targetActivity.startDate)).asMinutes() / 2, 'minutes').toDate()
      if (forward && eventEdgeDate.isBefore(threshold)) {
        targetIndex--
      } else if (!forward && eventEdgeDate.isAfter(threshold)) {
        targetIndex++
      }

      activities.splice(targetIndex, 0, activities.splice(currIndex, 1)[0])
      productionPlanningEvent.activities = activities
      this.chainActivities(productionPlanningEvent)
      this.moveActivityWithinWeek(eventId, postId, targetIndex)
    } else {
      info.revert()
    }
  }

  @transaction()
  onEventClick(info: EventClickArg) {

  }

  createElementFromHTML(htmlString: string): HTMLElement {
    const div = document.createElement('div');
    div.innerHTML = htmlString.trim();
    return div.firstChild as HTMLElement;
  }

  ngOnDestroy() {
    this.postEditListenerFn();

    if (this.subToDateChangesSubj) {
      this.subToDateChangesSubj.unsubscribe()
      this.subToDateChangesSubj = null;
    }
  }

  ngAfterViewInit() {
    this.postEditListenerFn = this.renderer.listen(document, 'click', (event) => {

      if (event.target && event.target.id.startsWith('event-')) {
        this.editPost(event.target.id.split('-')[1]);
      }

      if (event.target && event.target.id.startsWith('week-')) {
        this.changeDate(event.target.id.split('-')[1])
      }
    });
  }

  getUnsubFromAllSubs(): Subject<boolean> {
    return null
  }

  showHint(info: FcJsEvent, cls: string = 'event-shortcode') {
    if (!this.activitiesMap.has(info.event.id)) {
      return
    }
    this.activityInHint = this.activitiesMap.get(info.event.id)

    this.calendarEventTipService.showHint(info, cls);
  }

  hideHint() {
    this.calendarEventTipService.hideHint()
    this.activityInHint = null
  }

  editPost(id: string) {
    const post = this.postsMap.get(id).post
    const dialogRef = this.dialog.open(ProdPostEditorDialogComponent, {
      data: {
        post,
        postWeek: this.postsMap.get(id).postWeek
      },
      panelClass: 'prod-post-editor-dialog'
    });

    dialogRef.afterClosed().subscribe(() => {
      this.getEvents(this.startDate, this.endDate)
    })
  }

  private subToDateChanges() {
    this.subToDateChangesSubj.pipe(debounceTime(150)).subscribe(datesSetArg => {
      this.onDateChange(datesSetArg)
    })
  }

  private subToFilter() {
    this.filterSubj = this.productionPlanningProjectsService.prodPlanActivitiesSubj.subscribe(types => {
      this.filteredPostsSet.clear()
      types.forEach(type => {
        this.filteredPostsSet.add(type)
      })

      this.filterPosts()
    })
  }

  private onDateChange(info: DatesSetArg) {
    this.startDate = moment(info.start).format('YYYY-MM-DD');
    this.endDate = moment(info.end).format('YYYY-MM-DD');

    this.getEvents(this.startDate, this.endDate)
  }
}
